import { render } from "./ComplaintsReceiptAnalysisModal.vue?vue&type=template&id=e060d4c0"
import script from "./ComplaintsReceiptAnalysisModal.vue?vue&type=script&lang=js"
export * from "./ComplaintsReceiptAnalysisModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ComplaintsReceiptAnalysisModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_881c333e%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2FComplaintsReceiptAnalysisModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__